<template>
  <div class="explain">
    <BannerTop title="讲解" />
    <LivingRoom v-if="loaded && !hasExplain" :check-sv="checkSv" />
    <Skeleton animated :loading="!loaded">
      <template slot="template">
        <div style="padding: 0 16px;">
          <SkeletonItem variant="h1" style="width: 30%;" />
          <div v-for="i in [1, 2]" :key="i" class="flex-row" style="margin-bottom: 0.4rem">
            <SkeletonItem variant="image" style="width:3.3rem;height: 2rem;" />
            <div class="flex-col flex-jc-bt" style="width:4rem;margin-left: 0.4rem;">
              <SkeletonItem variant="h4" style="width: 80%" />
              <SkeletonItem variant="h4" style="width: 50%" />
              <SkeletonItem variant="h4" />
            </div>
          </div>
        </div>
      </template>
      <ExplainModule
        :explains="explains"
        :check-sv="checkSv"
        :get-reexplain-list="getReexplainList"
        :has-reexplain="hasReexplain"
        :has-right="hasViewExplainRight"
      />
    </Skeleton>
    <SameQuestionEntry v-if="isCanSameQuestion" />
    <LivingRoom v-if="loaded && hasExplain" :check-sv="checkSv" />
    <!-- 题目展示 -->
    <QuestionModule v-if="canShowYuanti" :attaches="attaches" show-jiucuo />
    <div class="jiucuo_btn flex-row flex-al-center" @click="tojiucuo">
      <img
        src="https://img.yzcdn.cn/upload_files/2020/12/25/Fm0McKMdXZIL4H3dcH6bpGOxfrMx.png"
        alt="icon"
      />
    </div>
  </div>
</template>
<script>
/**
 * 求讲解前后端分离
 * 2020.10.21
 * by suxue
 * 注释：求/看讲解是sv才有的特权
 */
import { Dialog, Toast } from 'vant'
import BannerTop from '../../../../components/BannerTop'
import ExplainModule from './components/explainModule'
import QuestionModule from './components/questionModule'
import LivingRoom from './components/livingRoom'
import SameQuestionEntry from './components/sameQuestionEntry'
import { mapState } from 'vuex'
import { adModel, relodPage } from '../../../../../library'
import { getOssBookQuestionJSON } from '@/api/ossBook'
import { getCorrectionList, getNumDetail, getReexplainList } from '@/api/explain'
import bookInfo from '@/pages/answer/route/answer/swiperAnswer/bookInfo'
import Skeleton from '@/components/Skeleton'
import SkeletonItem from '@/components/Skeleton/item'
import { checkExplainAuthority } from '@/ProductAuthority/SPU/explain'
export default {
  name: 'AnswerExplain',
  components: {
    SkeletonItem,
    Skeleton,
    ExplainModule,
    QuestionModule,
    BannerTop,
    LivingRoom,
    SameQuestionEntry
  },
  mixins: [bookInfo],
  data() {
    return {
      attaches: [],
      jiuCuo: false,
      loaded: false,
      noExplain: false,
      questionAttaches: [],
      canShowYuanti: false,
      hasReexplain: false
    }
  },
  computed: {
    ...mapState('user', ['openid', 'userInfo']),
    ...mapState('answerExplain', ['allExplains']),
    explains() {
      return this.allExplains || []
    },
    hasViewExplainRight() {
      const { workbookId } = this.$route.query
      const bookCategory = this.$store.state.mjBook.bookData[workbookId]?.bookJSON.category
      return checkExplainAuthority(this.userInfo, { bookCategory })
    },
    hasExplain() {
      return this.explains.length > 0
    }
  },
  created() {
    relodPage()
  },
  async mounted() {
    if (window._hmt) {
      window._hmt.push(['_trackEvent', 'funcTracker', 'visit', `访问看讲解页`])
    }
    this.getOssBook()
    this.$commit('answerExplain/setHasViewExplainRight', this.hasViewExplainRight)
    const { questionId, workbookId, chapterId } = this.$route.query
    this.$dispatch('answerExplain/getHasViewVideoExplain', { questionId })
    let res
    try {
      res = await getOssBookQuestionJSON(workbookId, chapterId, questionId)
    } catch (e) {
      Toast.clear()
      Toast('讲解模块维护中，请稍后再试！')
      setTimeout(() => {
        this.$router.back()
      }, 2000)
      return
    }
    // this.checkSv()

    var { attaches, explains } = res
    this.attaches = attaches
    // 没有讲解,看看是不是已经求过讲解了
    if (explains.length < 1) {
      this.noExplain = true
      Toast('本题暂无讲解')
      await this.getReexplainList()
    } else {
      // 有讲解查看评价列表
      await this.$store.dispatch('answerExplain/getEnjoyList', { explains })
      // 视频讲解播放喜欢次数查询
      const numList = await this.getExplaimNum(questionId)
      // 数据合并，留下视频讲解前三条
      explains = explains
        .map((i) => {
          const item = numList.find((j) => j.id === i.id)
          if (item) {
            return { ...i, ...item }
          } else {
            return {
              ...i
            }
          }
        })
        .filter((i) => !i.mediaType.includes('video') || i.index)
      this.$commit('answerExplain/setallExplains', { data: explains })
    }
    this.loaded = true
    u.rs.todotip('lookExplain')
  },
  destroyed() {
    this.$store.commit('answerExplain/clearStore')
  },
  methods: {
    // 无权限弹窗
    checkSv(cb) {
      if (!this.hasViewExplainRight) {
        this.$store
          .dispatch('mopaAd/getAd', {
            code: 'explainPage', // 页面
            cCodes: 'model', // 页面位置
            vipLevel: this.userInfo.vipLevel.toUpperCase(),
            equipment: this.$env.isIos
          })
          .then((res) => {
            // TODO
            const adItem = res[0] || {
              imgPath:
                'https://img01.yzcdn.cn/upload_files/2021/09/23/FusVwYqmZTB7SHBFVNcoDKiRRxvp.png',
              urlPath: '/cms/webapp/home/vipPay/index.html?channel=daanye_kjj_gn#/gv'
            }
            adModel({
              img: adItem.imgPath,
              link: adItem.urlPath,
              ad: adItem.externalOrg,
              click: () => {}
            })
            this.canShowYuanti = true
          })
      } else {
        this.canShowYuanti = true
        cb && cb()
      }
    },
    back() {
      this.$router.back()
    },
    // 是否求过讲解,子组件也会调用更新data
    getReexplainList() {
      return getReexplainList().then((res) => {
        const reexplainList = res.data.data || []
        const hasReexplain = reexplainList.find((i) => +i === +this.$route.query.questionId)
        this.hasReexplain = !!hasReexplain
        return hasReexplain
      })
    },
    async getExplaimNum(questionId) {
      const res = await getNumDetail(questionId)
      const num = res.data.data
      let indexMin = 2
      return num.map((i, index) => {
        if (i.sort === 1) {
          i.index = 1
        } else {
          i.index = Math.max(indexMin, index + 1)
          indexMin = i.index + 1
        }
        return i
      })
    },
    tojiucuo() {
      const { questionId, workbookId, chapterId, pageId } = this.$route.query
      getCorrectionList().then((res) => {
        const item = res.data.data.find((i) => +i.questionId === +questionId) || ''
        if (item && [0, 2].includes(item.status)) {
          Dialog.alert({
            message: '您已提交过纠错反馈'
          })
        } else {
          const query = {
            questionId,
            workbookId,
            chapterId,
            pageId,
            jiucuoId: item && item.id
          }
          if (!item) {
            delete query.jiucuoId
          }
          this.$router.push({
            path: '/explain/comment',
            query
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
.explain {
  background: #ffffff;
  min-height: 100vh;
  .jiucuo_btn {
    position: fixed;
    right: 26px;
    bottom: 86px;
    img {
      width: 42px;
    }
  }
}
</style>
